import PreferredLanguage from './PreferredLanguage';

export default PreferredLanguage;
